module.exports = __webpack_public_path__ + "img/arrow-down.084a3497.svg";